import React from "react";
import logo from "../assets/siblingo-logo.png";

export const SIBLINGO_LOGO = logo;
export const TAGLINE = "Dressed. Matched. Done.";

export function Logo({ className = "", height = "h-9", withTagline = false, taglineClassName = "" }) {
  const img = (
    <img
      src={logo}
      alt="SIBLINGO"
      data-testid="siblingo-logo"
      className={`${height} w-auto object-contain`}
    />
  );
  if (!withTagline) {
    return React.cloneElement(img, { className: `${img.props.className} ${className}` });
  }
  return (
    <span className={`inline-flex flex-col items-start leading-none ${className}`}>
      {img}
      <span
        data-testid="brand-tagline"
        className={`font-heading font-bold uppercase tracking-[0.18em] text-brand ${taglineClassName || "text-[10px] mt-1"}`}
      >
        {TAGLINE}
      </span>
    </span>
  );
}
